export const MEETING_BOOKING_SESSION_RECOMMEND_EVENT_NAME = 'meeting.booking.session.recommend' as const;
export const MEETING_BOOKING_SESSION_RECOMMEND_EVENT_KIND = 'scenario' as const;
export const MEETING_BOOKING_SUBJECT_TYPE = 'meeting_booking' as const;
export const MEETING_BOOKING_ACTION = 'recommend' as const;
export const POINT_HUB_SDK_VERSION = '0.2.4';
export const DEFAULT_POINT_HUB_SOURCE_TYPE = 'web';
export const DEFAULT_POINT_HUB_SOURCE_NAME = 'web-teams-client';
export const DEFAULT_POINT_HUB_ENTRY_SOURCE = 'schedule_entry' as const;
// Ripple ingestion raw_payload limit; HTTP body limit is 2 MiB.
export const DEFAULT_POINT_HUB_MAX_PAYLOAD_BYTES = 1572864;
export const POINT_HUB_DEDUPE_TTL_MS = 30 * 60 * 1000;
export const POINT_HUB_DEDUPE_MAX_ENTRIES = 500;

export const RIPPLE_MEETING_BOOKING_SCHEMA_DATE = '2026-06-30';

export const MEETING_BOOKING_PROPERTIES_KEYS = [
  'flow_id',
  'conversation_id',
  'platform',
  'entry_source',
  'booking_scene',
  'session_result',
  'booking_method',
  'ai_used',
  'manual_edit_after_ai',
  'started_at',
  'submitted_at',
  'closed_at',
  'duration_ms',
  'active_duration_ms',
  'idle_duration_ms',
  'ai_user_turn_count',
  'ai_recommendation_apply_count',
  'manual_edit_count',
  'manual_edited_field_count',
  'manual_edited_fields',
  'field_edit_detail',
  'final_form_snapshot',
  'latest_ai_snapshot',
  'ai_modified_fields_summary',
  'conversation_summary',
  'conversation_detail'
] as const;

export const BOOKING_FORM_SNAPSHOT_KEYS = [
  'meeting_subject',
  'meeting_subject_visibility',
  'participants',
  'meeting_pattern',
  'meeting_address',
  'meeting_online',
  'meeting_remind',
  'meeting_agenda',
  'meeting_type',
  'meeting_file',
  'auto_release_room',
  'public_address_book',
  'meeting_duration_limit',
  'service_items',
  'meeting_service_requirements',
  'restrictive_rules'
] as const;

export const BOOKING_LIST_ITEM_KEYS = ['label', 'value', 'name'] as const;
export const BOOKING_PARTICIPANT_KEYS = [
  ...BOOKING_LIST_ITEM_KEYS,
  'participant_id',
  'participant_name',
  'participant_role'
] as const;
export const BOOKING_MEETING_ADDRESS_KEYS = ['room_id', 'room_name', 'address_type'] as const;
export const BOOKING_ONLINE_MEETING_KEYS = [
  ...BOOKING_LIST_ITEM_KEYS,
  'online_type',
  'online_name',
  'auto_mute',
  'auto_record',
  'meeting_password'
] as const;
export const BOOKING_MEETING_REMIND_KEYS = ['remind_enabled', 'before_minutes'] as const;
export const BOOKING_MEETING_FILE_KEYS = [
  ...BOOKING_LIST_ITEM_KEYS,
  'file_id',
  'file_name',
  'file_size_mb'
] as const;
export const BOOKING_AUTO_RELEASE_ROOM_KEYS = ['enabled', 'after_minutes'] as const;
export const BOOKING_RESTRICTIVE_RULE_KEYS = [
  ...BOOKING_LIST_ITEM_KEYS,
  'rule_id',
  'rule_name',
  'rule_hit'
] as const;
export const MANUAL_EDITED_FIELD_KEYS = ['field_key', 'field_name', 'field_group', 'edit_count'] as const;
export const FIELD_EDIT_DETAIL_KEYS = [
  'edit_id',
  'edit_index',
  'occurred_at',
  'field_key',
  'field_name',
  'field_group',
  'after_ai_used',
  'changed_from_ai_prefill',
  'trigger_source',
  'old_value_type',
  'new_value_type',
  'old_value_text',
  'new_value_text',
  'old_value_number',
  'new_value_number',
  'old_value_bool',
  'new_value_bool',
  'old_value_list',
  'new_value_list',
  'edit_duration_ms',
  'is_final_value_kept'
] as const;
export const AI_MODIFIED_FIELD_SUMMARY_KEYS = [
  'field_key',
  'field_name',
  'field_group',
  'changed',
  'ai_value_text',
  'final_value_text',
  'ai_value_number',
  'final_value_number',
  'ai_value_bool',
  'final_value_bool',
  'ai_value_list',
  'final_value_list'
] as const;
export const AI_CONVERSATION_SUMMARY_KEYS = [
  'user_turn_count',
  'ai_turn_count',
  'first_ai_used_at',
  'last_ai_used_at'
] as const;
export const AI_CONVERSATION_DETAIL_KEYS = [
  'turn_index',
  'message_id',
  'occurred_at',
  'message_text',
  'message_length',
  'intent_type',
  'contains_time_expression',
  'contains_participant_expression'
] as const;
